module.exports = __webpack_public_path__ + "static/media/expressionless-face-svgrepo-com.aa3acc7c.svg";